// extracted by mini-css-extract-plugin
module.exports = {"label":"TransferFundsReviewStep_label__3SmEg","text":"TransferFundsReviewStep_text__2SCk3"};